export default {
  'PostureAdmin': {
    'restricted': [
      'help-text-editor'
    ]
  },
  'ComplianceManager': {
    'restricted': [
      'help-text-editor'
    ]
  },
  'ComplianceOfficer': {
    'restricted': [
      'help-text-editor',
      'company-profile-assessment',
      'hipaa-assessment',
      'marketplace'
    ]
  },
  'ContentEditor': {
    'restricted': [
      'company-profile-assessment',
      'hipaa-assessment',
      'marketplace'
    ]
  },
}


// WEBPACK FOOTER //
// ./src/components/hoc/permissions.js